<template>
  <div :class="hasWebp ? 'home' : 'home noWebp'">
    <div id="wrap">
      <div id="main">
        <div id="page1" :class="currentId === 0 ? 'page cu_page': 'page'">
          <video src="../assets/home_cn_bg1.mp4" class="video_bg" autoplay loop muted playsinline></video>
          <div class="main_content content_left" :style="scaleStr">
            <div class="page_title fadeInUp delay02">天识科技</div>
            <div class="page_title_trans fadeInUp delay04">全球云店<span class="point">——</span></div>
            <div class="page_title_des fadeInUp delay06">想法即商业，开店即开张</div>
            <A-Button text='联系我们' class="header_button dis_mb fadeInUp delay08" @onclick="changeWrap(9)"></A-Button>
            <A-Button text='预约演示' class="header_button glass_btn dis_mb fadeInUp delay08" @onclick="changeWrap(8)"></A-Button>
            <A-Button text='跨境零售RaaS解决方案' class="header_button show_mb fadeInUp delay08" @onclick="changeRouter('/cn/solution/raas')"></A-Button>
            <A-Button text='品牌出海BaaS解决方案' class="header_button show_mb fadeInUp delay08" @onclick="changeRouter('/cn/solution/baas')"></A-Button>
          </div>
          <img v-if="currentId === 0" src="../../static/imgs/home_cn_arrow_down.svg" alt="" class="upAndDown" @click="changeWrap(1)">
        </div>
        <div id="page2" :class="currentId === 1 ? 'page cu_page': 'page'">
          <div class="main_content" :style="scaleStr">
            <div class="page_title fadeInUp delay02">解决方案</div>
            <div class="main_bottom_box">
              <div class="main_item main_item2 fadeInUp delay04" @click="changeRouter('/cn/solution/baas')">
                <img src="../../static/imgs/home_cn_solution1.png" alt="img">
                <div class="main_title2">品牌出海直通车BaaS</div>
                <div class="main_text2">从产品本土化、营销本土化、渠道本土化三个方面，通过“咨询+软件+培训”为中国优质品牌定制一站式操盘解决方案，帮助中国品牌在国际上实现商业增长。</div>
              </div>
              <div class="main_item main_item2 fadeInUp delay06" @click="changeRouter('/cn/solution/raas')">
                <img src="../../static/imgs/home_cn_solution2.png" alt="img">
                <div class="main_title2">跨境零售直通车RaaS</div>
                <div class="main_text2">自己就能做跨境电商，多对一专家服务，保姆式培训投入少、启动快，ANTDIY助力中国卖家全球带货！</div>
              </div>
            </div>
          </div>
        </div>
        <div id="page3" :class="currentId === 2 ? 'page cu_page': 'page'">
          <div class="main_content" :style="scaleStr">
            <div class="page_title fadeInUp delay02">天眼赋能-抢占先机</div>
            <!-- <div class="page_title_trans fadeInUp delay04">Discover products before they’re trending</div> -->
            <div class="main_bottom_box fadeInUp delay06">
              <div class="main_bottom_left"></div>
              <div class="main_bottom_right">
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">大数据本地化洞察及早发现趋势</div>
                </div>
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">鸟瞰全球商业地图识别机会点</div>
                </div>
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">知己知彼，弯道超车的关键路径</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="page4" :class="currentId === 3 ? 'page cu_page': 'page'">
          <div class="main_content" :style="scaleStr">
            <div class="page_title fadeInUp delay02">拒绝“内卷”——守正出奇</div>
            <!-- <div class="page_title_trans fadeInUp delay04">A price war will not help you win the market</div> -->
            <div class="main_bottom_box box_reverse fadeInUp delay06">
              <div class="main_bottom_left"></div>
              <div class="main_bottom_right">
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">差异化营销方式拒绝价格内卷</div>
                </div>
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">精细化卓越运营盈利最大化</div>
                </div>
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">全球数字化供应链网络模型最优化成本</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="page5" :class="currentId === 4 ? 'page cu_page': 'page'">
          <div class="main_content" :style="scaleStr">
            <div class="page_title fadeInUp delay02">从0到1到N——破圈拓市</div>
            <!-- <div class="page_title_trans fadeInUp delay04">Adapt to the fast-changing market</div> -->
            <div class="main_bottom_box fadeInUp delay06">
              <div class="main_bottom_left"></div>
              <div class="main_bottom_right">
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">百亿销售额验证商业国际化地图</div>
                </div>
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">大数据AI组合拳扩展跨境流量地图</div>
                </div>
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">重构线上线下流通链路，全渠道打通</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="page6" :class="currentId === 5 ? 'page cu_page': 'page'">
          <div class="main_content" :style="scaleStr">
            <div class="page_title fadeInUp delay02">轻装上阵——精益迭代</div>
            <!-- <div class="page_title_trans fadeInUp delay04">Emerging marketing strategy to get you more traffic</div> -->
            <div class="main_bottom_box box_reverse fadeInUp delay06">
              <div class="main_bottom_left"></div>
              <div class="main_bottom_right">
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">揭秘轻资产“0”库存的运营模式</div>
                </div>
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">工程迭代验证趋势涌现的确定性</div>
                </div>
                <div class="main_right_item">
                  <div class="main_right_point">
                    <em></em>
                  </div>
                  <div class="main_right_text">战役地图，数字沙盘降低增长风险</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="page7" :class="currentId === 6 ? 'page cu_page': 'page'">
          <div class="main_content" :style="scaleStr">
            <div class="page_title fadeInUp delay02">暗知识的时代已经来临，你的认知正在阻碍你</div>
            <!-- <div class="page_title_trans fadeInUp delay04">Cognitive iterations with big date help brand growth</div> -->
            <div class="main_bottom_box">
              <div class="main_item fadeInUp delay06">
                <img src="../../static/imgs/home_cn_big_date1.svg" alt="img">
                <div class="main_en">Data resource</div>
                <div class="main_title">基于全球电商数据资源的<br>消费者认知和洞察</div>
                <div class="main_text">ANTDIY拥有全球最大的电商数据，洞悉海外市场的现状和发展趋势，以及消费者的痛点和需求；从产品本土化，营销本土化到渠道本土化决策都有据可循</div>
              </div>
              <div class="main_item fadeInUp delay08">
                <img src="../../static/imgs/home_cn_big_date2.svg" alt="img">
                <div class="main_en">Methodology</div>
                <div class="main_title">工程化测试推动<br>消费者认知和洞察</div>
                <div class="main_text">C2B的工程化测试，进行低成本高效的持续认知迭代，加速数据沉淀；从用户运营，市场营销到产品创新，打通数据壁垒，让测试数据“为我所用”</div>
              </div>
              <div class="main_item fadeInUp delay10">
                <img src="../../static/imgs/home_cn_big_date3.svg" alt="img">
                <div class="main_en">Technology</div>
                <div class="main_title">全球销售网络的<br>智能ERP</div>
                <div class="main_text">在ANTDIY一个平台管理多个线上渠道以及线下渠道的直销和分销；从产品、营销、客户、履约、仓配、物流等全方位实行电子商务自动化管理</div>
              </div>
            </div>
          </div>
        </div>
        <div id="page8" :class="currentId === 7 ? 'page cu_page': 'page'">
          <div class="main_content content_left" :style="scaleStr">
            <div class="page_title_big_trans fadeInUp delay02">Partners</div>
            <div class="page_title fadeInUp delay04">我们的合作伙伴</div>
            <img class="page_partners fadeInUp delay06" src="../../static/imgs/home_cn_partners.svg" alt="">
            <img class="page_partners_mb" src="../../static/imgs/home_cn_partners_m.svg" alt="">
          </div>
        </div>
        <div id="page9" :class="currentId === 8 ? 'page cu_page': 'page'">
          <div class="main_content" :style="scaleStr">
            <div class="page_title fadeInUp delay02">预约<span>免费</span>演示</div>
            <em class="book_line"></em>
            <div class="page_title_trans fadeInUp delay04">Book a demo</div>
            <div class="book_bottom fadeInUp delay06">
              <div class="book_lt">
                <div class="book_lt_title">
                  请留下联系方式，我们客户经理将会在一个工作日内联系您并预约具体演示的时间
                </div>
                <div class="book_lt_bottom">
                  <div class="book_lt_item">
                    <img src="/static/imgs/home_cn_book_1.svg" alt="">
                    专人一对一详细解答
                  </div>
                  <div class="book_lt_item">
                    <img src="/static/imgs/home_cn_book_2.svg" alt="">
                    详细了解系统功能
                  </div>
                  <div class="book_lt_item">
                    <img src="/static/imgs/home_cn_book_3.svg" alt="">
                    系统实操全流程演示
                  </div>
                  <div class="book_lt_item">
                    <img src="/static/imgs/home_cn_book_4.svg" alt="">
                    提供专业解决方案
                  </div>
                </div>
              </div>
              <div class="book_rt">
                <div class="book_rt_item">
                  <div class="book_rt_item_tel" >中国大陆+86</div>
                  <input type="text" placeholder="请输入电话" v-model="telephone" @input="write(1)" :disabled="disabled" :style="disabled ? 'cursor:no-drop' : ''">
                </div>
                <p class="book_test book_test2" v-if="error">请输入正确的手机号</p>
                <div class="book_rt_item2">
                  <input type="text" placeholder="请输入验证码" v-model="code" @input="write(2)">
                  <div class="book_item_button" v-if="showcode" @click="getcode">发送验证码</div>
                  <div class="book_item_button" v-else :disabled="disabled" :style="disabled ? 'cursor:no-drop' : ''">{{waittime+'s'}}</div>
                </div>
                <p class="book_test"  v-if="error2">请输入正确的验证码</p>
                <input type="text" class="book_item_input" placeholder="输入您的姓名" v-model="name" @input="write(3)">
                <p class="book_test" v-if="error3">请输入您的姓名</p>
                <input type="text" class="book_item_input" placeholder="输入公司名称" v-model="company" @input="write(4)">
                <p class="book_test" v-if="error4">请输入公司名称</p>
                <div>
                  <select v-model="language" class="product_consult_select" >
                    <option value="zh">语言-中文</option>
                    <option value="en">语言-英语</option>
                  </select>
                </div>
                <div class="book_submit" @click="submit">提交</div>
              </div>
            </div>
          </div>
        </div>
        <div id="page10" class="page">
          <FooterCN></FooterCN>
        </div>
      </div>
    </div>
    <div class="wrap_cycles">
      <div :class="'cycle cycle' + index + (index === currentId ? ' cycle_active': '')" v-for="(item, index) in cicleData" :key="index" @click="changeWrap(index)">
        <em></em>
        <div class="cycle_text">{{item}}</div>
      </div>
    </div>
    <div class="product_consult_ordermobile" v-if="success">
      <div class="product_consult_success">
        <img src="/static/imgs/consult_close.svg" alt="" class="close" @click="success=false;">
        <h1 class="product_consult_order_title">您已成功预约</h1>
        <div class="product_consult_order_line"></div>
        <h2 class="product_consult_order_subtitle">客户经理将会在<span>1个工作日</span>内联系您并预约具体演示的时间。</h2>
        <img src="/static/imgs/success.svg" alt="" class="success_img">
      </div>
    </div>
  </div>
</template>

<script>
import FooterCN from './common/footerCNNew.vue';
export default {
  components:{
    FooterCN,
  },
  props: ['hasWebp'],
  data(){
    return{
      currentId: 0,
      currentPx: 0,
      cicleData: ['天识科技', '解决方案', '发现商机', '赢得市场', '市场环境', '跨境营销', '品牌成长', '合作伙伴', '预约演示', '联系我们'],
      scale: 1,
      startTime:0,
      endTime:0,
      scaleStr:'',

      telephone:'',
      code:'',
      name:'',
      company:'',
      error:false,
      error2:false,
      error3:false,
      error4:false,
      waittime: 59,
      showcode:true,
      disabled:false,
      codery: '',
      language: 'zh',
      success: false,
    }
  },
  methods:{
    goLink (url) {
      window.open(url)
    },
    write(index){
      if(index==1){
        this.error=false
      }else if(index==2){
        this.error2=false
      }else if(index==3){
        this.error3=false
      }else if(index==4){
        this.error4=false
      }
    },
    getcode(){
      let reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      if(this.telephone=='' || !reg.test(this.telephone)){
        this.error=true
        return
      }
      this.showcode=false
      this.count()
      this.disabled=true
      let params={
        "phone": this.telephone,
        "type": 1,
        "name": "天识信息科技",
        "template": `SMS_237060511`,
        "code": this.codery
      }
      this.$axios.post('https://gateway.antdiy.vip/alibaba-service/sms',params).then(res=>{
      })
    },
    count() {
      let siv = setInterval(() => {
        this.waittime--;
        if (this.waittime <= -1) {
          clearInterval(siv);
          this.waittime = 59;
          this.showcode=true;
          this.disabled=false
        }
      }, 1000);
    },
    submit(){
      let index=1
      let reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      if(this.telephone=='' || !reg.test(this.telephone)){
        this.error=true
        index=index-1
      }
      if(this.code=='' || this.code!=this.codery){
        this.error2=true
        index=index-1
      }
      if(this.name==''){
        this.error3=true
        index=index-1
      }
      // if(this.company==''){
      //   this.error4=true
      //   index=index-1
      // }
      if(index==1){
        let params={
          "phone": this.telephone,
          "type": 1,
          "name": "天识信息科技",
          "template": `SMS_237065530`,
          "code": this.codery
        }
        this.$axios.post('https://gateway.antdiy.vip/alibaba-service/sms',params).then(res=>{

        })
        this.$axios.get(`https://gateway.antdiy.vip/website/chat/0b5c1899805ec43213876bc1ce2a703b5f2758a1f7052c316fd8a00459e420aa`,{
          params:{
            message: `客户需要预约演示，请售前尽快联系安排！\n客户电话：${this.telephone}\n客户姓名：${this.name}\n公司名称：${this.company}\n客户语言:${this.language==='en' ? '英语': '中文'}`
          }
        }).then(res=>{
           this.success=true;
           this.telephone=this.name=this.code=this.company=''
        })
      }

    },
    changeWrap(id) {
      if (window.innerWidth < 767) {
        let page = document.querySelector("#page9")
        window.scrollTo({ 'behavior': 'smooth', 'top': page.offsetTop })
        return;
      }
      var len = window.innerHeight - 90;
      var main = document.getElementById("main");
      if (!main) return;
      this.currentId = id;
      this.currentPx = -id*len;
      main.style.top = this.currentPx + "px";
    },
    changeSize() {
      var len = window.innerHeight;
      if (len - 90 < 925) {
        this.scale = (len - 90)/925;
      } else {
        this.scale = 1;
      }
      if (this.scale < 0.5) {
        this.scale = 0.5;
      }
      this.scaleStr = `transform: translateY(${-(1-this.scale)/2*100}%) scale(${this.scale});`;
      this.changeWrap(this.currentId);
    },
    scrollFun(e) {
      var len = window.innerHeight - 90;

      this.startTime = new Date().getTime();
      var event = e || window.event;
      var dir = event.detail || -event.wheelDelta;
      if (this.startTime - this.endTime > 1000) {
        if (dir > 0 && this.currentPx > -9 * len) {
          this.currentId += 1;
          this.changeWrap(this.currentId);
          this.endTime = new Date().getTime();
        } else if (dir < 0 && this.currentPx < 0) {
          this.currentId -= 1;
          this.changeWrap(this.currentId);
          this.endTime = new Date().getTime();
        }
      } else {
        event.preventDefault();
      }
    },
    unRegisterEvent() {
      if (navigator.userAgent.toLowerCase().indexOf("firefox") != -1) {
        document.removeEventListener("DOMMouseScroll", this.scrollFun, { passive: false });
      } else if (document.addEventListener) {
        document.removeEventListener("mousewheel", this.scrollFun, { passive: false });
      } else if (document.attachEvent) {
        document.detachEvent("onmousewheel", this.scrollFun);
      } else {
        document.onmousewheel = undefined;
      }
      window.onresize = undefined;
    },
    registerEvent() {
      if (window.innerWidth <= 767) {
        return;
      }
      if (navigator.userAgent.toLowerCase().indexOf("firefox") != -1) {
        document.addEventListener("DOMMouseScroll", this.scrollFun, { passive: false });
      } else if (document.addEventListener) {
        document.addEventListener("mousewheel", this.scrollFun, { passive: false });
      } else if (document.attachEvent) {
        document.attachEvent("onmousewheel", this.scrollFun);
      } else {
        document.onmousewheel = this.scrollFun;
      }
      // 修改页面大小
      this.changeSize();
      window.onresize = ()=>{
        this.changeSize();
      }
    },
    changeRouter (link) {
      this.$router.push({
        path: link
      }).catch(err => {
      // console.log('e',err)
      })
    },
    playVideo() {
      let video = document.querySelector('.video_bg');
      // console.log(video)
      if (video) {
        video.play();
        setTimeout(()=>{
          video.play();
        },3000)
      } else {
        setTimeout(() => {
          this.playVideo();
        }, 500);
      }
    }
  },
  created(){
    document.title = '全球云店——想法即商业，开店即开张';;;
    let code= Math.floor(Math.random()*900000+100000)
    localStorage.setItem('code',code)
    this.codery=localStorage.getItem('code')
  },
  mounted() {
    this.registerEvent();
    this.playVideo();

    let video = document.querySelector('.video_bg');
    video.addEventListener("click", function(event) {
      event.preventDefault();
    });
    video.addEventListener("play", function(event) {
      event.preventDefault();
    });
  },
  beforeRouteEnter(to, from, next) {
    next((vm)=>{
      vm.registerEvent()
      vm.playVideo();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.unRegisterEvent()
    next();
  },
}
</script>

<style scoped>
  .home {
    background-color: #02021D;
  }
  #wrap {
    width: 100%;
    height:  calc(100vh - 90px);
    overflow: hidden;
    /* margin-top: -90px; */
  }

  #main {
    width: 100%;
    position: relative;
    transition: 0.25s all;
    top: 0px;
  }

  .page {
    width: 100%;
    margin: 0;
    height: calc(100vh - 90px);
    padding-top: 0;
    position: relative;
  }

  #page1 {
    background: url("/static/imgs/home_cn_bg1.webp") center/cover;
  }
  .noWebp #page1 {
    background: url("/static/imgs/home_cn_bg1.png") center/cover;
  }
  #page1 video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  #page1 .main_content {
    padding-top: 150px;
  }
  #page1 .page_title {
    font-size: 90px;
    letter-spacing: 7.5px;
  }
  #page1 .page_title_trans {
    font-size: 53px;
    letter-spacing: 4.42px;
    margin-top: 65px;
  }
  .page_title_trans .point {
    letter-spacing: 0;
  }
  #page1 .page_title_des {
    color: #FFFFFF;
    letter-spacing: 3.5px;
    margin-top: 40px;
  }
  .header_button {
    width: 234px;
    height: 58px;
    display: inline-block;
    text-align: center;
    padding: 0;
    line-height: 56px;
    font-size: 24px;
    font-family: SourceHanSansCN-Medium !important;
    color: #FFFFFF;
    letter-spacing: 2.55px;
    margin-top: 116px;
    /* background: #FB5421; */
    box-shadow: 0px 6px 16px 0px rgba(251,84,33,0.33);
    border-radius: 8px;
    font-weight: 500;
  }
  .header_button + .header_button {
    margin-left: .4rem;
  }
  .glass_btn {
    background: rgba(251,84,33,0.15);
    border: 1.5px solid rgba(251,84,33,0.85);
    box-shadow: 0px 6px 16px 0px rgba(255,144,85,0.26);
    border-radius: 8px;
    line-height: 53px;
    backdrop-filter: blur(10px);
  }
  .glass_btn:hover{
    background: rgba(251,84,33,0.30);
    /* border: 1.5px solid rgba(251,84,33,0.85); */
    box-shadow: 0px 6px 16px 0px rgba(255,144,85,0.26);
    border-radius: 8px;
  }
  .show_mb {
    display: none;
  }
  .dis_mb {
    display: inline-block;
  }
  #page1 img {
    position: fixed;
    left: 50%;
    bottom: 82px;
    width: 60px;
    transform: translateX(-50%);
    cursor: pointer;
  }


  #page3 {
    background: url("/static/imgs/home_cn_bg2.webp") center/cover;
  }
  .noWebp #page3 {
    background: url("/static/imgs/home_cn_bg2.png") center/cover;
  }

  #page4 {
    background: url("/static/imgs/home_cn_bg3.webp") center/cover;
  }
  .noWebp #page4 {
    background: url("/static/imgs/home_cn_bg3.png") center/cover;
  }

  #page5 {
    background: url("/static/imgs/home_cn_bg4.webp") center/cover;
  }
  .noWebp #page5 {
    background: url("/static/imgs/home_cn_bg4.png") center/cover;
  }

  #page6 {
    background: url("/static/imgs/home_cn_bg5.webp") center/cover;
  }
  .noWebp #page6 {
    background: url("/static/imgs/home_cn_bg5.png") center/cover;
  }

  #page7 {
    background: url("/static/imgs/home_cn_bg6.png") center/cover;
  }
  #page7 .main_bottom_box {
    margin-top: 160px;
  }

  #page2 {
    background: url("/static/imgs/home_cn_bg7.png") center/cover;
  }
  #page2 .main_content {
    padding-top: 80px;
  }
  #page2 .main_bottom_box {
    margin-top: 100px;
  }

  #page8 {
    background: url("/static/imgs/home_cn_bg8.png") center/cover;
  }
  #page8 .main_content {
    padding-top: 12px;
  }
  #page8 .page_title {
    margin-bottom: 133px;
  }

  #page9 {
    background: url("/static/imgs/home_cn_bg9.png") center/cover;
  }
  #page9 .page_title span {
    display: none;
  }

  #page10 {
    background: #010119;
    display: flex;
    align-items: center;
    overflow-x: hidden;
    overflow-y: auto;
    /* 隐藏滚动条 */
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }
  #page10::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .main_content {
    margin: 0 auto;
    width: 1280px;
    text-align: center;
    color: #FFFFFF;
    padding-top: 100px;
  }
  .content_left {
    text-align: left;
  }

  .page_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 48px;
    letter-spacing: 0.67px;
    font-weight: 700;
  }
  .page_title_des {
    font-family: SourceHanSansCN-Regular !important;
  }
  .page_title_trans, .page_title_des {
    font-family: Helvetica;
    font-size: 36px;
    letter-spacing: 0.9px;
    font-weight: 400;
    margin-top: 35px;
  }
  .page_title_big_trans {
    font-family: Helvetica-Bold;
    font-size: 68px;
    letter-spacing: 1.7px;
    font-weight: 700;
    margin-top: 82px;
  }
  .main_bottom_box {
    display: flex;
    margin-top: 74px;
    justify-content: space-between;
  }
  .box_reverse {
    flex-direction: row-reverse;
  }

  .main_bottom_left {
    width: 612px;
    height: 529px;
    opacity: 0;
  }
  .main_bottom_right {
    width: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .main_right_item {
    display: flex;
    position: relative;
  }
  .main_right_item + .main_right_item {
    margin-top: 68px;
  }
  .main_right_point {
    width: 28px;
    min-width: 28px;
    height: 28px;
    border: 1px solid #FFFFFF;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 23px;
    margin-top: 7px;
  }
  .main_right_point em {
    display: block;
    width: 20px;
    height: 20px;
    background-color: #FFFFFF;
    border-radius: 50%;
  }
  .main_right_text {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 30px;
    color: #FFFFFF;
    letter-spacing: 2.14px;
    font-weight: 700;
    text-align: left;
    /* position: absolute; */
    /* left: 51px; */
    /* width: 579px; */
  }

  .main_item {
    width: 410px;
    padding: 40px 33px 60px;
    background: rgb(252, 83, 34, 0.28);
    box-shadow: 0px 5px 4px 0px rgba(167,167,167,0.06);
    border-radius: 10px;
  }
  .main_item img{
    height: 93px;
  }
  .main_en {
    opacity: 0.8;
    font-family: Helvetica;
    font-size: 22px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 28px;
    font-weight: 400;
    margin-top: 20px;
  }
  .main_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 26px;
    color: #FFFFFF;
    letter-spacing: 0.65px;
    text-align: center;
    line-height: 32px;
    font-weight: 700;
    margin-top: 17px;
  }
  .main_text {
    opacity: 0.85;
    font-family: SourceHanSansCN-Regular !important;
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 0.62px;
    text-align: justify;
    line-height: 28px;
    font-weight: 400;
    margin-top: 20px;
  }

  .main_item2 {
    width: 618px;
    padding: 39px 54px;
    transition: all 1s;
    position: relative;
    top: 0;
    cursor: pointer;
  }
  .main_item2:hover {
    top: -30px;
  }
  .main_item2 img {
    margin: -39px -54px 0;
    width: 618px;
    height: auto;
  }
  .main_title2 {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 34px;
    color: #FFFFFF;
    letter-spacing: 0.85px;
    line-height: 32px;
    font-weight: 700;
    margin-top: 34px;
  }
  .main_text2 {
    opacity: 0.85;
    font-family: SourceHanSansCN-Regular !important;
    font-size: 22px;
    color: #FFFFFF;
    letter-spacing: 0.69px;
    text-align: justify;
    line-height: 30px;
    font-weight: 400;
    margin-top: 22px;
  }
  .page_partners {
    width: 100%;
  }
  .page_partners_mb {
    width: 100%;
    display: none;
  }

  .book_bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 94px;
  }
  .book_lt {
    width: 600px;
  }
  .book_lt_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 30px;
    color: #FFFFFF;
    letter-spacing: 2.14px;
    line-height: 40px;
    font-weight: 700;
  }
  .book_lt_bottom {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 34px;
  }
  .book_lt_item {
    display: flex;
    align-items: center;
    font-family: SourceHanSansCN-Regular !important;
    font-size: 24px;
    color: #E4DCDC;
    letter-spacing: 0.33px;
    font-weight: 400;
    margin-top: 36px;
  }
  .book_lt_item img{
    width: 40px;
    min-width: 40px;
    margin-right: 20px;
  }
  .book_rt {
    width: 550px;
    display: flex;
    flex-direction: column;
  }
  .book_rt input, .book_rt select {
    height: 50px;
    width: 100%;
    border: 1px solid rgba(206,206,206,0.7);
    border-radius: 8px;
    background-color: #F5F7FC;
    font-family: SourceHanSansCN-Regular !important;
    font-size: 18px;
    color: #7F8489;
    font-weight: 400;
    padding: 0 23px;
    margin-bottom: 25px;
  }
  .book_rt input::placeholder {
    color: #7F8489;
  }
  .book_rt select option {
    color: #010119;
  }
  .book_rt input:focus, .book_rt select:focus {
    border-color: #fc5322;
  }
  .book_test {
    margin-bottom: 25px;
  }
  .book_rt_item {
    display: flex;
  }
  .book_rt_item input {
    border-left: unset;
    border-radius: 0 8px 8px 0;
  }
  .book_rt_item_tel {
    background-image: linear-gradient(180deg, #FFFFFF 0%, #E5E5E5 100%);
    border: 1px solid rgba(151,151,151,0.5);
    border-radius: 8px 0px 0px 8px;
    min-width: 150px;
    width: 150px;
    height: 50px;
    line-height: 50px;
    font-family: SourceHanSansCN-Regular !important;
    font-size: 18px;
    color: #4C4C4C;
    font-weight: 400;
  }
  .book_rt_item2 {
    display: flex;
  }
  .book_item_button {
    width: 164px;
    min-width: 164px;
    height: 50px;
    line-height: 50px;
    background: #FC5322;
    box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
    border-radius: 4px;
    margin-left: 27px;
    font-family: SourceHanSansCN-Medium !important;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0.56px;
    text-align: center;
    font-weight: 500;
    cursor: pointer;
  }
  .book_submit {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #FC5322;
    box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
    border-radius: 4px;
    font-family: SourceHanSansCN-Medium !important;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0.5px;
    text-align: center;
    font-weight: 500;
    cursor: pointer;
    margin-top: .35rem;
  }

  .wrap_cycles {
    position: fixed;
    bottom: auto;
    left: auto;
    right: 3.3854%;
    top: calc(50% + 35px);
    transform: translateY(-50%);
  }
  .cycle {
    cursor: pointer;
    z-index: 1;
    position: relative;
  }
  .cycle:hover em, .cycle_active em {
    opacity: 0;
  }
  .cycle:hover .cycle_text, .cycle_active .cycle_text {
    display: block;
  }
  .cycle + .cycle {
    margin-top: 24px;
  }
  .cycle em{
    display: inline-block;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #FFFFFF;
  }
  .cycle_text {
    position: absolute;
    right: 0;
    top: 0;
    white-space: nowrap;
    font-family: SourceHanSansCN-Medium !important;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 1.29px;
    font-weight: 500;
    display: none;
  }

  @keyframes upAndDown{
    0% {
      -webkit-transform:translate3d(0,0,0);
      transform:translate3d(0,0,0)
    }
    70% {
      -webkit-transform:translate3d(0,50%,0);
      transform:translate3d(0,50%,0)
    }
    to {
      -webkit-transform:translateZ(0);
      transform:translateZ(0)
    }
  }
  @-webkit-keyframes upAndDown{
    0% {
      -webkit-transform:translate3d(0,0,0);
      transform:translate3d(0,0,0)
    }
    70% {
      -webkit-transform:translate3d(0,50%,0);
      transform:translate3d(0,50%,0)
    }
    to {
      -webkit-transform:translateZ(0);
      transform:translateZ(0)
    }
  }
  .upAndDown {
    animation: upAndDown 2s ease-in-out infinite;
    -webkit-animation: upAndDown 2s ease-in-out infinite;
  }

  @-webkit-keyframes fadeInUp {
    0% {
      opacity:0;
      -webkit-transform:translate3d(0,100%,0);
      transform:translate3d(0,100%,0)
    }
    to {
      opacity:1;
      -webkit-transform:translateZ(0);
      transform:translateZ(0)
    }
  }
  @keyframes fadeInUp{
    0% {
      opacity:0;
      -webkit-transform:translate3d(0,100%,0);
      transform:translate3d(0,100%,0)
    }
    to {
      opacity:1;
      -webkit-transform:translateZ(0);
      transform:translateZ(0)
    }
  }
  .cu_page .fadeInUp {
    -webkit-animation-name:fadeInUp;
    animation-name:fadeInUp;
    -webkit-animation-duration:2s;
    animation-duration:2s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  .delay02 {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
  }
  .delay04 {
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
  }
  .delay06 {
    -webkit-animation-delay: 0.6s;
    animation-delay: 0.6s;
  }
  .delay08 {
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
  }
  .delay10 {
    -webkit-animation-delay: 1s;
    animation-delay: 1s;
  }
  .delay12 {
    -webkit-animation-delay: 1.2s;
    animation-delay: 1.2s;
  }

  .product_consult_ordermobile{
    width: 100%;
    background: rgba(0,0,0,.5);
    z-index: 999;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  .product_consult_success{
    width: 568px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 2px 15px 0px rgba(221,221,221,0.43);
    border-radius: 20px;
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index:1000;
    padding: 40px 80px 60px;
  }
  .success_img{
    width: 274px;
    height: 294px;
    display: block;
    margin: 45px auto 0;
  }
  .close{
    position: absolute;
    right: 60px;
    top:28px;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  .product_consult_order_title{
    font-family: SourceHanSansCN-Bold !important;
    font-size: 36px;
    color: #222536;
    letter-spacing: 0.5px;
    text-align: center;
    font-weight: 700;
  }
  .product_consult_order_line{
    width: 60px;
    height: 8px;
    background: #FC5421;
    border-radius: 6px;
    margin: 24px auto 26px;
  }
  .product_consult_order_subtitle{
    font-family: SourceHanSansCN-Medium !important;
    font-size: 18px;
    color: #222536;
    letter-spacing: 0.25px;
    text-align: center;
    line-height: 26px;
    font-weight: 500;
  }
  .product_consult_order_subtitle span{
    color: #FB2F31;
  }

  @media(max-width:767px){
    #wrap {
      height: fit-content;
      margin-top: 1.6rem;
    }

    #main {
      top: 0;
    }

    .page {
      height: fit-content;
      padding-top: 0;
      margin-top: -0.02rem;
    }

    #page1 {
      position: relative;
      background: url("/static/imgs/home_cn_mbg1.webp") center/cover;
    }
    .noWebp #page1 {
      background: url("/static/imgs/home_cn_mbg1.png") center/cover;
    }
    #page1 video {
      width: auto;
      left: -100%;
      z-index: -1;
    }
    #page1 .main_content {
      padding: 1.65rem 0.48rem 1.7rem;
    }
    #page1 .page_title {
      font-size: .6rem;
      letter-spacing: 0.05rem;
    }
    #page1 .page_title_trans {
      font-size: .35rem;
      letter-spacing: 0.0292rem;
      margin-top: .62rem;
    }
    #page1 .page_title_des {
      letter-spacing: 0.0233rem;
      margin-top: .3rem;
    }
    .header_button {
      width: 100%;
      height: fit-content;
      padding: 0.2rem 0.8rem;
      border-radius: 0.08rem;
      font-size: .3rem;
      line-height: .3rem;
      letter-spacing: .0273rem;
      margin-right: 0 !important;
      margin-top: 1.16rem;
      box-shadow: 0 .06rem .16rem 0 rgba(251,84,33,0.33);
    }
    .header_button + .header_button {
      margin-left: 0;
      /* margin-top: .32rem; */
    }
    .header_button:nth-child(2n - 1) {
      margin-top: .32rem;
    }
    .dis_mb {
      display: none;
    }
    .show_mb {
      display: inline-block;
    }
    #page1 {
      z-index: 10;
    }
    #page1 img {
      display: none;
    }

    #page3 {
      background: url("/static/imgs/home_cn_mbg2.webp") center/cover;
      /* margin-top: -.6rem;
      z-index: 9; */
    }
    .noWebp #page3 {
      background: url("/static/imgs/home_cn_mbg2.png") center/cover;
      /* margin-top: -.6rem;
      z-index: 9; */
    }
    #page3 .page_title {
      margin-top: 1.2rem !important;
    }
    #page3 .main_bottom_box {
      margin-top: 0 !important;
    }

    #page4 {
      background: url("/static/imgs/home_cn_mbg3.webp") center/cover;
      /* margin-top: -.6rem;
      z-index: 8; */
    }
    .noWebp #page4 {
      background: url("/static/imgs/home_cn_mbg3.png") center/cover;
    }
    #page4 .page_title {
      margin-top: 1.2rem !important;
    }
    #page4 .main_bottom_box {
      margin-top: 0 !important;
    }

    #page5 {
      background: url("/static/imgs/home_cn_mbg4.webp") center/cover;
      /* margin-top: -.6rem;
      z-index: 7; */
    }
    .noWebp #page5 {
      background: url("/static/imgs/home_cn_mbg4.png") center/cover;
    }
    #page5 .page_title {
      margin-top: 1.2rem !important;
    }
    #page5 .main_bottom_box {
      margin-top: 0 !important;
    }

    #page6 {
      background: url("/static/imgs/home_cn_mbg5.webp") center/cover;
      /* background-image: radial-gradient(circle at 50% 57%, #060834 0%, #02021D 46%); */
      /* margin-top: -.6rem;
      z-index: 6; */
    }
    .noWebp #page6 {
      background: url("/static/imgs/home_cn_mbg5.png") center/cover;
    }
    #page6 .page_title {
      margin-top: 1.2rem !important;
    }
    #page6 .main_bottom_box {
      margin-top: 0 !important;
    }

    #page7 {
      background: url("/static/imgs/home_cn_mbg6.png") center/cover;
    }

    #page2 {
      background-image: radial-gradient(circle at 50% 57%, #060834 0%, #02021D 46%);
    }
    #page2 .main_content {
      padding-top: .9rem;
    }

    #page8 {
      background-image: radial-gradient(circle at 50% 57%, #060834 0%, #02021D 46%);
    }
    #page8 .main_content {
      padding-top: .7rem;
      text-align: center;
    }
    #page8 .page_title {
      margin: .18rem 0 .5rem;
    }

    #page9 {
      background-image: radial-gradient(circle at 50% 57%, #060834 0%, #02021D 46%);
    }
    #page9 .page_title span {
      display: inline-block;
    }
    #page9 .page_title_trans {
      display: none;
    }

    #page10 {
      background: #010119;
      display: flex;
      align-items: center;
      overflow-x: hidden;
      overflow-y: auto;
      /* 隐藏滚动条 */
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
    }
    #page10::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .main_content {
      margin: 0 auto;
      width: 100%;
      text-align: center;
      color: #FFFFFF;
      padding: .75rem .48rem;
    }
    .content_left {
      text-align: left;
    }

    .page_title {
      font-size: .4rem;
      letter-spacing: 0.0056rem;
    }
    .page_title_trans, .page_title_des {
      font-size: .28rem;
      letter-spacing: 0.007rem;
      margin-top: .3rem;
    }
    .page_title_trans .point {
      letter-spacing: 0;
    }
    .page_title_big_trans {
      font-size: .44rem;
      letter-spacing: 0.011rem;
      margin-top: 0;
    }
    .main_bottom_box {
      margin-top: .6rem !important;
      flex-direction: column;
    }
    .box_reverse {
      flex-direction: column;
    }

    .main_bottom_left {
      width: 100%;
      height: calc(100vw - 1.2rem);
      opacity: 0;
    }
    .main_bottom_right {
      width: 100%;
      margin-top: .6rem;
    }
    .main_right_item {
      display: flex;
      position: relative;
    }
    .main_right_item + .main_right_item {
      margin-top: .35rem;
    }
    .main_right_point {
      width: .28rem;
      min-width: .28rem;
      height: .28rem;
      border: .01rem solid #FFFFFF;
      border-radius: 50%;
      margin-right: .23rem;
      margin-top: .044rem;
    }
    .main_right_point em {
      width: .2rem;
      height: .2rem;
    }
    .main_right_text {
      font-size: .28rem;
      letter-spacing: .02rem;
      font-weight: 700;
      position: relative;
      left: 0;
      width: fit-content;
    }

    .main_item {
      width: 100%;
      padding: .57rem .5264rem .65rem;
      background: rgb(252, 83, 34, 0.28);
      box-shadow: 0 .05rem .04rem 0 rgba(167,167,167,0.06);
      border-radius: .1rem;
    }
    .main_item + .main_item {
      margin-top: .35rem;
    }
    .main_item img{
      height: 1.72rem;
    }
    .main_en {
      font-size: .28rem;
      line-height: .28rem;
      margin-top: .28rem;
    }
    .main_title {
      font-size: .34rem;
      letter-spacing: .0085rem;
      line-height: .44rem;
      margin-top: .25rem;
    }
    .main_text {
      font-size: .28rem;
      letter-spacing: .0088rem;
      line-height: .36rem;
      margin-top: .25rem;
    }

    .main_item2 {
      width: 100%;
      padding: .34rem .39rem;
    }
    .main_item2 img {
      margin: -.34rem -.39rem 0;
      width: calc(100% + .78rem);
      height: auto;
    }
    .main_title2 {
      font-size: .34rem;
      letter-spacing: .0085rem;
      line-height: .32rem;
      margin-top: .36rem;
    }
    .main_text2 {
      font-size: .24rem;
      letter-spacing: .0075rem;
      line-height: .32rem;
      margin-top: .3rem;
      min-height: 1.28rem;
    }
    .page_partners {
      display: none;
    }
    .page_partners_mb {
      display: block;
    }

    .book_line {
      display: inline-block;
      width: .6rem;
      height: .08rem;
      background: #FC5421;
      border-radius: 6px;
      margin: .3rem 0 .35rem;
    }
    .book_bottom {
      flex-direction: column;
      margin-top: 0;
    }
    .book_lt {
      width: 100%;
    }
    .book_lt_title {
      font-size: .24rem;
      letter-spacing: .0033rem;
      line-height: .32rem;
      font-weight: 500;
      padding: 0 .4rem;
    }
    .book_lt_bottom {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      margin: .35rem 0 .76rem;
    }
    .book_lt_item {
      font-size: .24rem;
      letter-spacing: .0033rem;
      margin-top: .36rem;
    }
    .book_lt_item img{
      width: .24rem;
      min-width: .24rem;
      margin-right: .24rem;
    }
    .book_rt {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    .book_rt input, .book_rt select {
      height: .6rem;
      border: .01rem solid rgba(206,206,206,0.7);
      border-radius: .08rem;
      font-size: .18rem;
      font-weight: 400;
      padding: 0 .23rem;
      margin-bottom: .25rem;
    }
    .book_test {
      margin-bottom: .25rem;
    }

    .book_rt_item input {
      border-left: unset;
      border-radius: 0 .08rem .08rem 0;
    }
    .book_rt_item_tel {
      border: .01rem solid rgba(151,151,151,0.5);
      border-radius: .08rem 0px 0px .08rem;
      min-width: 1.72rem;
      width: 1.72rem;
      height: .6rem;
      line-height: .6rem;
      font-size: .18rem;
    }
    .book_item_button {
      width: 1.64rem;
      min-width: 1.64rem;
      height: .6rem;
      line-height: .6rem;
      box-shadow: 0px .06rem .08rem 0px rgba(252,83,34,0.1);
      border-radius: .04rem;
      margin-left: .27rem;
      font-size: .18rem;
      letter-spacing: .0056rem;
    }
    .book_submit {
      height: .6rem;
      line-height: .6rem;
      background: #FC5322;
      box-shadow: 0px .06rem .08rem 0px rgba(252,83,34,0.1);
      border-radius: .04rem;
      font-size: .24rem;
      letter-spacing: .0075rem;
    }

    .wrap_cycles {
      display: none;
    }
    .upAndDown {
      animation: unset;
      -webkit-animation: unset;
    }
    .cu_page .fadeInUp {
      -webkit-animation-name: unset;
      animation-name: unset;
      -webkit-animation-duration: unset;
      animation-duration: unset;
      -webkit-animation-fill-mode: unset;
      animation-fill-mode: unset;
    }

    .product_consult_success{
      width: 5.68rem;
      height: auto;
      background: #FFFFFF;
      box-shadow: 0px .02rem .15rem 0px rgba(221,221,221,0.43);
      border-radius: .2rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      padding: .4rem .8rem .6rem;
    }
    .success_img{
      width: 2.74rem;
      height: 2.94rem;
      display: block;
      margin: .45rem auto 0;
    }
    .close{
      right: .7rem;
      top:.28rem;
      width: .4rem;
      height: .4rem;
    }
    .product_consult_order_title{
      font-size: .4rem;
      letter-spacing: 0.005rem;
    }
    .product_consult_order_line{
      width: .6rem;
      height: .08rem;
      border-radius: .6rem;
      margin: .29rem auto .3rem;
    }
    .product_consult_order_subtitle{
      font-size: .24rem;
      letter-spacing: 0.0033rem;
      line-height: .32rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homecnNew.vue